import React, {useContext} from 'react'
import {GlobalLangCtx} from '../../App'
import './MindsetComp.css'

const MindsetComp = () =>{
    
    const [globalLan] = useContext(GlobalLangCtx);
    const {main_title, fileJson} = require(`../json_archivies/mindset_${globalLan}.js`);


    const path = "./code_it_img/"

    const jsx_values = fileJson.map((el, idx) =>{
        return (
            <div key={idx} className='mindset_block'>
                <div className='title_blk'>
                    { el.title }
                </div>
                <div className='image_blk'>
                        <img className='imgStyle' src={path + el.img} alt="" />
                </div>
                <div className="desc">
                    <p className='descParag'>
                        {el.desc}
                    </p>
                </div>
            </div>
        )
    })

    return (
        <section className='mindsetMainContainer'>

            <h1 className='main_title'>
                { main_title.title }
            </h1>

            <div className='containerBlb'>                    
                { jsx_values }        
            </div>

            
        </section>
    )
}

export default MindsetComp;